import productsPromptModalSlice from './slice';

// eslint-disable-next-line import/prefer-default-export
export const { setProductsPromptModalState } = productsPromptModalSlice.actions;
